interface AttemptTrackerProps {
  attemptsLabel: string;
}

export function AttemptTracker({ attemptsLabel }: AttemptTrackerProps) {
  return <p>{attemptsLabel}</p>;
}

